{
    "(save {highestYearlyDiscount}%)": "(estalvies {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dies gratuïts",
    "{amount} off": "{amount} de descompte",
    "{amount} off for first {number} months.": "{amount} de descompte pels primers {number} mesos",
    "{amount} off for first {period}.": "{amount} de descompte pels primers {period}.",
    "{amount} off forever.": "{amount} de descompte per sempre.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% de descompte",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "En/na {memberEmail} ja no rebrà cap més butlletí de {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "En/na {memberEmail} no rebrà cap més correu electrònic quan algú respongui als teus comentaris.",
    "{memberEmail} will no longer receive this newsletter.": "En/na {memberEmail} ja no rebrà més aquest butlletí.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dies de prova",
    "{years} years": "",
    "+1 (123) 456-7890": "+34 123 456 789",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Compte",
    "Account details updated successfully": "Detalls del compte actualitzats correctament",
    "Account settings": "Configuració del compte",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Després que finalitzi el període de prova gratuït, se't cobrarà el preu estipulat del nivell que hagis triat. Sempre pots cancel·lar abans que això passi.",
    "Already a member?": "Ja n'ets membre?",
    "An error occurred": "Ha succeït un error",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Ha succeït un error inesperat. Si-us-plau, torna a provar-ho o <a>contacta amb suport tècnic</a> si l'error persisteix.",
    "Back": "Torna enrere",
    "Back to Log in": "Torna a l'inici de sessió",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Cancel·la en qualsevol moment.",
    "Cancel subscription": "Cancel·la la subscripció",
    "Canceled": "",
    "Cancellation reason": "Motiu de la cancel·lació",
    "Change": "Canvia",
    "Change plan": "Canvia pla",
    "Check spam & promotions folders": "Comprova les carpetes de correu brossa i promocions",
    "Check with your mail provider": "Consulta el teu proveïdor de correu",
    "Check your inbox to verify email update": "Comprova la teva safata d'entrada per verificar el canvi d'adreça d'email",
    "Choose": "Tria",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Selecciona un pla diferent",
    "Choose a plan": "Selecciona un pla",
    "Choose a tier": "",
    "Choose your newsletters": "Selecciona els teus butlletins",
    "Click here to retry": "Fes clic aquí per tornar-ho a intentar",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Tanca",
    "Code": "",
    "Comment preferences updated.": "Preferències de comentaris actualitzades",
    "Comments": "Comentaris",
    "Complimentary": "Gratuït",
    "Confirm": "Confirma",
    "Confirm cancellation": "Confirma cancel·lació",
    "Confirm subscription": "Confirma subscripció",
    "Contact support": "Contacta amb suport tècnic",
    "Continue": "Continua",
    "Continue subscription": "Continua subscripció",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "No s'ha pogut crear una sessió de pagament amb Stripe",
    "Could not sign in. Login link expired.": "No s'ha pogut iniciar sessió. L'enllaç d'inici de sessió ha expirat.",
    "Could not update email! Invalid link.": "No s'ha pogut actualitzar el correu electrònic! Enllaç no vàlid.",
    "Create a new contact": "Crea un nou contacte",
    "Current plan": "Pla actual",
    "Delete account": "Esborra compte",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "No volies fer això? Gestiona les teves preferències <button>aquí</button>.",
    "Don't have an account?": "No tens un compte?",
    "Edit": "Edita",
    "Email": "Correu electrònic",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Butlletí informatiu per correu electrònic",
    "Email newsletter settings updated": "Preferències de butlletins actualitzades",
    "Email preferences": "Preferències del correu electrònic",
    "Email preferences updated.": "Preferències del correu electrònic actualitzades",
    "Emails": "Correus electrònics",
    "Emails disabled": "Correus electrònics desactivats",
    "Ends {offerEndDate}": "Finalitza el {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Escriu la teva adreça d'email",
    "Enter your name": "Escriu el teu nom",
    "Error": "Error",
    "Expires {expiryDate}": "Expira el {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "No s'ha pogut cancel·lar la subscripció. Si-us-plau, torna-ho a intentar",
    "Failed to log in, please try again": "No s'ha pogut iniciar sessió. Si-us-plau, torna-ho a intentar",
    "Failed to log out, please try again": "No s'ha pogut tancar la sessió. Si-us-plau, torna-ho a intentar",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "No s'ha pogut processar el pagament. Si-us-plau, torna-ho a intentar",
    "Failed to send magic link email": "No s'ha pogut enviar l'email amb l'enllaç màgic",
    "Failed to send verification email": "No s'ha pogut enviar l'email de verificació",
    "Failed to sign up, please try again": "No s'ha pogut completar el registre. Si-us-plau, torna-ho a intentar",
    "Failed to update account data": "No s'han pogut actualitzar les dades del compte",
    "Failed to update account details": "No s'han pogut actualitzar els detalls del compte",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "No s'ha pogut actualitzar la configuració del butlletí",
    "Failed to update subscription, please try again": "No s'ha pogut actualitzar la subscripció. Si-us-plau, torna-ho a intentar",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "per sempre",
    "Free Trial – Ends {trialEnd}": "Prova gratuita - Finalitza el {trialEnd}",
    "From": "",
    "Get help": "Demana ajuda",
    "Get in touch for help": "Posa't en contacte per obtenir ajuda",
    "Get notified when someone replies to your comment": "Rep notificacions quan algú et respongui al teu comentari",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Envia comentaris sobre aquesta publicació",
    "Help! I'm not receiving emails": "Ajuda! No rebo correus electrònics",
    "Here are a few other sites you may enjoy.": "Aquí tens alguns altres llocs que et poden agradar.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Si un butlletí es marca com a correu brossa, els correus electrònics es desactivaran automàticament per a aquesta adreça per assegurar-te que ja no reps cap missatge no desitjat.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Si la queixa de correu brossa va ser accidental, o si vols començar a rebre correus electrònics de nou, pots tornar a subscriure't als correus electrònics fent clic al botó de la pantalla anterior.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Si cancel·les la teva subscripció ara, continuaràs tenint-hi accés fins al {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Si tens un compte de correu electrònic corporatiu o governamental, posa't en contacte amb el teu departament de TI i demana'ls-hi que permetin rebre correus electrònics de {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "S'ha enviat un enllaç d'inici de sessió al teu correu electrònic. Si no t'arriba en 3 minuts, revisa la teva carpeta de correu brossa.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Si vols començar a rebre correus electrònics de nou, el millor que pots fer és comprovar si hi ha cap problema a la teva adreça de correu electrònic i, a continuació, fes clic a tornar a subscriure's a la pantalla anterior.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Si no reps el butlletí electrònic al qual t'has subscrit, aquí tens algunes coses per comprovar.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Si has completat totes aquestes comprovacions i encara no reps correus electrònics, pots contactar amb {supportAddress} per obtenir assistència.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "En cas que es rebi un error permanent en intentar enviar un butlletí, els correus electrònics es desactivaran en aquest compte.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Afegeix {senderEmail} a la llista de contactes del teu client de correu electrònic. Això indica al teu proveïdor de correu que els correus electrònics enviats des d'aquesta adreça haurien de ser de confiança.",
    "Invalid email address": "Adreça de correu electrònic invàlida",
    "Invalid verification code": "",
    "Jamie Larson": "Josep Jaume Casademunt",
    "jamie@example.com": "josepjaume@exemple.cat",
    "Less like this": "Menys d'aquest tipus",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Assegura't que els correus electrònics no acabin accidentalment a les carpetes Correu brossa o Promocions de la teva safata d'entrada. Si això passa, fes clic a \"Marca com a NO correu brossa\" i/o a \"Mou a la safata d'entrada\".",
    "Manage": "Gestiona",
    "Maybe later": "Potser més tard",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Membresies no disponibles. Posa't en contacte amb el propietari per accedir-hi.",
    "month": "mes",
    "Monthly": "Mensual",
    "More like this": "Més d'aquest tipus",
    "More options": "",
    "Name": "Nom",
    "Need more help? Contact support": "Necessites més ajuda? Contacta amb suport tècnic",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Els butlletins de notícies poden estar desactivats al teu compte per dos motius: un correu electrònic anterior s'ha marcat com a correu brossa o bé s'ha intentat enviar un correu electrònic que ha provocat un error permanent (rebot).",
    "No member exists with this e-mail address.": "No existeix cap membre amb aquesta adreça d'email",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "No reps els correus electrònics?",
    "Now": "",
    "Now check your email!": "Revisa ara el teu correu electrònic!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Un cop et tornis a subscriure, si encara no reps correus electrònics a la teva safata d'entrada, comprova la carpeta de correu brossa. Alguns proveïdors de correu mantenen un registre de les queixes de correu brossa anteriors i continuaran marcant els correus electrònics com a tal. Si això passa, marca el darrer butlletí com a \"No és correu brossa\". ' per tornar-lo a moure a la safata d'entrada principal.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Falla permanent (rebot)",
    "Phone number": "Número de telèfon",
    "Plan": "Pla",
    "Plan checkout was cancelled.": "S'ha cancel·lat el pagament del pla.",
    "Plan upgrade was cancelled.": "S'ha cancel·lat l'actualització del pla.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Posa't en contacte amb {supportAddress} per ajustar la teva subscripció gratuïta.",
    "Please enter {fieldName}": "Si-us-plau, introdueix {fieldName}",
    "Please fill in required fields": "Si-us-plau, omple els camps obligatoris",
    "Podcasts": "",
    "Re-enable emails": "Torna a activar els correus electrònics",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Recomanacions",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Es renova a {price}",
    "Resume subscription": "",
    "Retry": "Torna-ho a provar",
    "Save": "Desa",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Enviant enllaç d'inici de sessió...",
    "Sending...": "Enviant",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Mostra'ls tots",
    "Sign in": "Inicia sessió",
    "Sign out": "Tanca sessió",
    "Sign up": "Registra't",
    "Signup error: Invalid link": "Error de registre: Enllaç no vàlid",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Quelcom no ha funcionat. Si-us-plau, torna-ho a intentar més tard.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Ho sentim, no hi ha cap recomanació ara mateix.",
    "Sorry, that didn’t work.": "Em sap greu, però no ha funcionat.",
    "Spam complaints": "Queixes de correu brossa",
    "Start {amount}-day free trial": "Comença el període de proves de {amount} dies",
    "Starting {startDate}": "A partir de {startDate}",
    "Starting today": "Comença avui",
    "Submit feedback": "Envia comentaris",
    "Subscribe": "Subscriu-te",
    "Subscribed": "Subscrit",
    "Subscription plan updated successfully": "Pla de subscripció actualitzat correctament",
    "Success": "Exitosament",
    "Success! Check your email for magic link to sign-in.": "Fantàstic! Comprova el teu correu electrònic per trobar l'enllaç màgic per iniciar la sessió.",
    "Success! Your account is fully activated, you now have access to all content.": "Fantàstic! El teu compte està totalment activat. Ara tens accés a tot el contingut.",
    "Success! Your email is updated.": "Fantàstic! El teu correu electrònic està actualitzat.",
    "Successfully unsubscribed": "T'has donat de baixa correctament",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Gràcies per subscriure't. Abans de començar a llegir, et mostrem alguns altres llocs que et poden agradar.",
    "Thank you for your support": "Gràcies pel teu recolzament",
    "Thank you for your support!": "Gràcies pel teu recolzament!",
    "Thanks for the feedback!": "Gràcies pels teus comentaris!",
    "That didn't go to plan": "Això no ha anat com estava previst",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "L'adreça electrònica que tenim per a tu és {memberEmail}; si no és correcta, pots actualitzar-la a l'<button>àrea de configuració del teu compte</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Hi ha hagut un problema en enviar els teus comentaris. Torna-ho a provar una mica més tard.",
    "There was an error cancelling your subscription, please try again.": "Hi ha hagut un problema en cancel·lar la teva subscripció. Torna-ho a provar.",
    "There was an error continuing your subscription, please try again.": "Hi ha hagut un problema en reprendre la teva subscripció. Torna-ho a provar.",
    "There was an error processing your payment. Please try again.": "Hi ha hagut un problema processant el teu pagament. Torna-ho a provar.",
    "There was an error sending the email, please try again": "Hi ha hagut un problema en enviar el correu. Torna-ho a provar.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Aquest lloc web és accessible només per invitació, contacta amb el propietari per obtenir-hi accés.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Aquest lloc web no està acceptant pagaments en aquests moments.",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Per completar el registre, fes clic sobre l'enllaç de confirmació al teu correu electrònic. Si no t'arriba en 3 minuts, revisa la teva carpeta de correu brossa!",
    "To continue to stay up to date, subscribe to {publication} below.": "Per a mantenir-te'n al dia, subscriute a {publication} més avall.",
    "Too many attempts try again in {number} days.": "Massa intents - Torna-ho a intentar en {number} dies.",
    "Too many attempts try again in {number} hours.": "Massa intents - Torna-ho a intentar en {number} hores.",
    "Too many attempts try again in {number} minutes.": "Massa intents - Torna-ho a intentar en {number} minuts.",
    "Too many different sign-in attempts, try again in {number} days": "Massa intents d'inici de sessió diferents - Torna-ho a intentar en {number} dies.",
    "Too many different sign-in attempts, try again in {number} hours": "Massa intents d'inici de sessió diferents - Torna-ho a intentar en {number} hores.",
    "Too many different sign-in attempts, try again in {number} minutes": "Massa intents d'inici de sessió diferents - Torna-ho a intentar en {number} minuts.",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Provar de manera gratuïta durant {amount} dies i després {originalPrice}.",
    "Unable to initiate checkout session": "No s'ha pogut iniciar el pagament",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Desbloqueja l'accés a tots els butlletins fent-te subscriptor de pagament.",
    "Unsubscribe from all emails": "Cancel·la les subscripcions a tots els correus electrònics",
    "Unsubscribed": "S'ha cancel·lat la subscripció",
    "Unsubscribed from all emails.": "S'ha cancel·lat la subscripció de tots els correus electrònics",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Cancel·lar la subscripció no cancel·larà la teva subscripció de pagament a {title}",
    "Update": "Actualitza",
    "Update your preferences": "Actualitza les teves preferències",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Enllaç de verificació enviat, comprova la teva safata d'entrada",
    "Verify your email address is correct": "Verifica que la teva adreça de correu electrònic és correcta",
    "Verifying...": "",
    "View plans": "Mostra plans",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "No hem pogut cancel·lar la teva subscripció ja que no s'ha trobat l'adreça de correu electrònic. Si-us-plau, contacta amb el propietari del lloc web.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Benvingut/da de nou, {name}!",
    "Welcome back!": "Benvingut/da de nou!",
    "Welcome to {siteTitle}": "Benvingut/da a {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Quan una safata d'entrada no accepta un correu electrònic s'anomena, habitualment, un rebot. En molts casos, això pot ser temporal. Tanmateix, en alguns casos, un correu electrònic rebutjat es pot retornar com a error permanent quan una adreça de correu electrònic no és vàlida o no existeix.",
    "Why has my email been disabled?": "Per què s'ha desactivat el meu correu electrònic?",
    "X (Twitter)": "",
    "year": "any",
    "Yearly": "Anual",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Actualment tens una subscripció gratuïta. Actualitza a una subscripció de pagament per accedir-hi.",
    "You have been successfully resubscribed": "T'has tornat a subscriure amb èxit",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Actualment no reps correus electrònics",
    "You're not receiving emails": "No estàs rebent correus electrònics",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "No estàs rebent correus electrònics perquè l'has marcat recentment com a correu brossa o perquè no s'han pogut entregar els missatges a l'adreça de correu electrònic proporcionada.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Has iniciat la sessió correctament.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "T'has subscrit correctament a <strong>{siteTitle}</strong>",
    "Your account": "El teu compte",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "La teva adreça de correu no s'ha pogut tornar a subscriure - torna-ho a intentar",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "La teva opinió ajuda a definir què es publica.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "La teva subscripció caducarà el {expiryDate}",
    "Your subscription will renew on {renewalDate}": "La teva subscripció es renovarà el {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "La teva subscripció començarà el {subscriptionStart}"
}
